// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-footnote-cover_root__gbVDQ"};